<template>
  <div>
    <ManageFeedsInfoDialog ref="manageFeedsInfoDialog"></ManageFeedsInfoDialog>
    <v-row>
      <v-col md="12">
        <!-- <p class="text-center headline font-weight-bold pb-5">{{$t('manageFeeds.general.Manage Feeds')}}</p> -->
        <div class="pb-5 d-flex">
          <span class="display-1 pt-1 font-weight-bold">{{$t('manageFeeds.general.Manage Feeds')}}</span>
          <span>
            <v-btn :title="$t('manageFeeds.general.Click to see more information')" @click.stop="$refs.manageFeedsInfoDialog.openDialog()" icon large>
              <v-icon color="primary">far fa-question-circle</v-icon>
            </v-btn>
          </span>
        </div>
        <v-row>
          <!--Get all the feeds of the customer-->
          <v-col md="6" v-for="item in customFeed" :key="item.feedId">
            <v-card class="mx-auto" max-width="600" outlined>
              <v-list-item three-line>
                <v-list-item-content>
                  <p class="headline" style="display:flex;">
                    <span>{{item.feedTitle}} </span>
                    <v-spacer></v-spacer> 
                    <v-btn class="mt-2" text :title="$t('manageFeeds.general.Edit')">
                      <v-icon large>far fa-edit</v-icon> 
                    </v-btn>
                  </p>
                  <v-row>
                    <v-col md="3">
                      <v-list-item-title class="subtitle-1 mb-1 font-weight-bold">{{$t('manageFeeds.general.Geo tags')}} :</v-list-item-title>
                    </v-col>
                    <v-col md="7">
                      <!--Get all the geo tags-->
                      <div v-for="geo in geoTags" :key="geo.feedId">
                        <!--Match the geo tags to the user through feedID-->
                        <div v-if="item.feedId == geo.feedId">
                          <div>
                            <!--As the tags are an array within geoTags, iterate and print them out-->
                            <span class="mr-2 subtitle-1 success--text" style="cursor: pointer;" v-for="tagsingeo in geo.tags" :key="tagsingeo.feedId">{{tagsingeo}}</span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col md="2">
                      <v-icon large>mdi-comment-edit-outline</v-icon>
                    </v-col>
                    <v-col md="3">
                      <v-list-item-title class="subtitle-1 mb-1 font-weight-bold">{{$t('manageFeeds.general.Hash tags')}} :</v-list-item-title>
                    </v-col>
                    <v-col md="9">
                      <!--Get all the hashtags-->
                      <div v-for="hash in hashTags" :key="hash.feedId">
                        <!--Match the hashtags to the user through feedID-->
                        <div v-if="item.feedId == hash.feedId">
                          <div>
                            <!--As the hashtags are an array within Hashtags, iterate and print em out-->
                            <span class="mr-2 subtitle-1 primary--text" style="cursor: pointer;" v-for="myhash in hash.hashtags" :key="myhash.feedId">
                              {{myhash}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import messages from "./modules/lang/main/export";
import ManageFeedsInfoDialog from "@/components/informational_dialogs/private/manageFeeds_info_dialog.vue";
export default {
  i18n: { messages },
  components:{
    ManageFeedsInfoDialog
  },
  data(){
    return{
      manageFeedsInfoDialog: false,
      // tags
      hashTags:[
        {feedId:1, hashtags:['#Football', '#Liverpool']},
        {feedId:2, hashtags:['#Vodka', '#Entertainment', '#Party']},
        {feedId:3, hashtags:['#Rock collection', '#Nature stuff']},
        {feedId:4, hashtags:['#World news', '#Festivals', 'Fancy drinks']},
        {feedId:5, hashtags:['#Candy', '#Health']},
      ],
      geoTags:[
        {feedId:1, tags:['#London', '#France']},
        {feedId:2, tags:['#Russia', '#China', '#Vladimir street 101']},
        {feedId:3, tags:['#Bartevegen 19', '#Norway']},
        {feedId:4, tags:['#England', '#London', 'Nutsack Street 64']},
        {feedId:5, tags:['#Sweden', '#Åre']},
      ],
      customFeed:[
        {feedId:1, feedTitle:"custom feed 1"},
        {feedId:2, feedTitle:"custom feed 2"},
        {feedId:3, feedTitle:"custom feed 3"},
        {feedId:4, feedTitle:"custom feed 4"},
        {feedId:5, feedTitle:"custom feed 5"}
      ],
    }
  }
}
</script>